import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseOrderURL = `api/v1/purchase-app/purchase-order`;

//obtaining the paginated data
export const getPurchaseOrder = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseOrderURL}/list?party_type=supplier&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseOrder = () => axiosInstance.get(`${purchaseOrderURL}/list?party_type=supplier&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseOrder = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseOrderURL}/list?party_type=supplier&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

// get purchase order additional charge list
export const getPurchaseOrderAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getPurchaseOrderById = (id) => axiosInstance.get(`${purchaseOrderURL}/retrieve/${id}`);

//get sale order detail from sale order master id
export const getSaleOrderDetail = (id) =>
  axiosInstance.get(`api/v1/sales-app/sales-order-detail/list/dropdown?salesOrderMain=${id}`);

//creating function
export const createPurchaseOrder = (body) => axiosInstance.post(`${purchaseOrderURL}/create`, body);
//updating function
export const updatePurchaseOrder = (id, body) => axiosInstance.patch(`${purchaseOrderURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseOrderURL}/list?party_type=supplier&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

export const getPurchaseOrderChargeStatus = (type) =>
  axiosInstance.get(`api/v1/core-app/additional-charge-status/list?transaction_type=${type}&is_active=true`);
